"use client";
import { Button } from "@/app/components/shadcn/button";
import { ChevronRight } from "lucide-react";
import Link from "next/link";
import useSearch from "@/app/lib/features/search/search.hook";
import SpecialProductsSkeleton from "@/app/components/elements/skeletons/SpecialProductsSkeleton";
import SearchSpecialProductsSwiper from "../../../swipers/SearchSpecialProductsSwiper";

interface SpecialProductsProps {
  onClose: () => void;
}

const SpecialProducts = ({ onClose }: SpecialProductsProps) => {
  const { specialProducts, isLoading } = useSearch();

  if (isLoading) return <SpecialProductsSkeleton />;
  if (!specialProducts || specialProducts.items.length === 0) return null;

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <h2 className="font-medium text-sm sm:text-base">
          {specialProducts.title}
        </h2>
        {specialProducts.slug && specialProducts.button_text && (
          <Button
            variant="link"
            asChild
            className="p-0 text-main gap-1 text-xs sm:text-sm"
          >
            <Link href={`/${specialProducts.slug}`} onClick={onClose}>
              {specialProducts.button_text}
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </Link>
          </Button>
        )}
      </div>
      <SearchSpecialProductsSwiper
        products={specialProducts.items}
        onClose={onClose}
      />
    </div>
  );
};

export default SpecialProducts;
